import { MouseEventHandler } from 'react'

import { Button } from 'components/common'

import { ExportIcon, FilterIcon } from 'components/icons'

import DataTableImportButton from './dataTableImportButton'
import SearchBar from './searchBar'
import { ImportColumn } from 'components/common/importModal'

type Props = {
  showFilter: boolean
  isEditor: boolean
  handleFilter?: MouseEventHandler<HTMLButtonElement>
  handleImport?: (data: any) => Promise<any>
  handleExport?: MouseEventHandler<HTMLButtonElement>
  placeholder?: string
  loading?: boolean
  importColumns?: ImportColumn[]
  importModuleName?: string
  importSampleFileUrl?: string
  onDownloadSample?: () => Promise<void>
}

const DataTableControllerWithoutCol = ({
  showFilter,
  isEditor,
  handleFilter,
  handleImport,
  handleExport,
  placeholder,
  loading,
  importColumns,
  importModuleName,
  importSampleFileUrl,
  onDownloadSample,
}: Props) => {
  return (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
      {/* Search bar */}
      <SearchBar placeholder={placeholder} disabled={loading || showFilter} />

      {/* Table Actions */}
      <div className="flex flex-wrap items-center gap-1">
        <Button
          buttonText="Filters"
          className={`rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary ${
            showFilter && 'bg-gray-200'
          } hover:bg-gray-200`}
          variant="custom"
          icon={<FilterIcon />}
          iconClassName="text-dataTableIcon"
          onClick={handleFilter}
          disabled={loading}
        />
        <Button
          type="button"
          buttonText="Export"
          variant="custom"
          iconClassName="!h-5 !w-5 text-dataTableIcon"
          icon={<ExportIcon />}
          className="rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200"
          onClick={handleExport}
          disabled={loading}
        />
        {isEditor && handleImport && (
          <DataTableImportButton
            disabled={loading}
            uploadApiFunction={handleImport}
            importColumns={importColumns}
            importModuleName={importModuleName}
            importSampleFileUrl={importSampleFileUrl}
            onDownloadSample={onDownloadSample}
          />
        )}
      </div>
    </div>
  )
}

export default DataTableControllerWithoutCol
